import { AuthActions } from "../LoginRedux/Action";
import { RackReduxActions } from "./Action";

let rackState = {
  AddRackData: null,
  AddRackError: null,
  ExportRackData: null,
  ExportRackError: null,
};

export const rackReducer = (state = rackState, { type, payload }) => {
  switch (type) {
    case RackReduxActions.ADD_UPDATE_RACK_SUCCESS:
      return {
        ...state,
        AddRackData: payload,
        AddRackError: null,
      };

    case RackReduxActions.ADD_UPDATE_RACK_FAILURE:
      return {
        ...state,
        AddRackData: null,
        AddRackError: payload,
      };
    case RackReduxActions.EXPORT_RACK_SUCCESS:
      return {
        ...state,
        ExportRackData: payload,
        ExportRackError: null,
      };

    case RackReduxActions.EXPORT_RACK_FAILURE:
      return {
        ...state,
        ExportRackData: null,
        ExportRackError: payload,
      };

    default:
      return state;
  }
};
